/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type FieldType =
  | 'ACTION_FIELD'
  | 'ENROLLMENT_FIELD'
  | 'DATA_SOURCE_FIELD'
  | unhandledEnumCase;

export const AgentInstanceBindingTypename =
  'com.hubspot.automation.templatesrpc.models.AgentInstanceBinding';
export const AgentInstanceBindingDiscriminant = 'AGENT_INSTANCE';
export const AgentInstanceBindingDiscriminantKey = 'type';
/**
 *  Binds every Run Agent action the template leaves open (those without an agent specified in
 *  the template's agent manifest) to an existing agent instance.
 */
export type AgentInstanceBinding = {
  agentInstanceId: number;
  __typename: 'com.hubspot.automation.templatesrpc.models.AgentInstanceBinding';
} & { type?: 'AGENT_INSTANCE' };

export const AssetBindingDiscriminantKey = 'type';
export type AssetBinding = AgentInstanceBinding;

export type AssetBindingNotAppliedReason =
  | 'ASSET_NOT_FOUND'
  | 'ASSET_NOT_BINDABLE'
  | 'NO_MATCHING_SLOT'
  | 'UNSUPPORTED_TARGET_TYPE'
  | 'CONFLICTING_BINDINGS'
  | 'RESOLUTION_ERROR'
  | unhandledEnumCase;

/**
 *  What instantiation did with one {@link AssetBinding}. {@code reason} and {@code message} are
 *  present only when {@code status} is {@code NOT_APPLIED}.
 */
export type AssetBindingResult = {
  binding: AssetBinding;
  status: AssetBindingStatus;
  reason?: AssetBindingNotAppliedReason;
  message?: string;
};

export type AssetBindingStatus = 'APPLIED' | 'NOT_APPLIED' | unhandledEnumCase;

export type GetInstantiationStatusError = {
  reason: GetInstantiationStatusErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetInstantiationStatusErrorReason =
  | 'TASK_NOT_FOUND'
  | 'MISSING_CONTEXT'
  | unhandledEnumCase;

export type GetInstantiationStatusRequest = { taskId: number };

export type GetInstantiationStatusResponse = {
  status: InstantiationStatus;
  targetType: Default<InstantiationTargetType>;
  viewLocation?: WorkflowViewLocation;
  flowId?: number;
  failureReason?: InstantiationFailureReason;
  failureMessage?: string;
  assetBindingResults: Default<AssetBindingResult[]>;
};

export type InstantiateTemplateError = {
  reason: InstantiateTemplateErrorReason;
  unresolvedValues: Default<UnresolvedManifestEntry[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type InstantiateTemplateErrorReason =
  | 'TEMPLATE_NOT_FOUND'
  | 'DOCUMENT_STORE_ERROR'
  | 'INTERNAL_ERROR'
  | 'PREFLIGHT_FAILED'
  | 'RESOLUTION_FAILED'
  | 'ENQUEUE_FAILED'
  | 'UNSUPPORTED_TARGET_TYPE'
  | 'MISSING_SCOPES'
  | unhandledEnumCase;

export type InstantiateTemplateRequest = {
  templateId: number;
  targetType: Default<InstantiationTargetType>;
  assetBindings: Default<AssetBinding[]>;
};

export type InstantiateTemplateResponse = {
  templateId: number;
  taskId: number;
};

export type InstantiatedTemplateItem = {
  flowId: number;
  workflowName?: string;
  enabled?: boolean;
  deleted?: boolean;
  createdAt?: number;
  updatedAt?: number;
  totalEnrolled?: number;
  taskId?: number;
};

export type InstantiationFailureReason =
  | 'FLOW_PREPARATION_FAILED'
  | 'FLOW_CREATION_FAILED'
  | 'ENQUEUE_FAILED'
  | unhandledEnumCase;

export type InstantiationRequestItem = {
  taskId: number;
  templateId: number;
  userId?: number;
  status: InstantiationStatus;
  targetType: InstantiationTargetType;
  viewLocation?: WorkflowViewLocation;
  flowId?: number;
  workflowName?: string;
  failureReason?: InstantiationFailureReason;
  failureMessage?: string;
  createdAt: number;
  updatedAt: number;
};

export type InstantiationStatus =
  | 'PENDING'
  | 'CREATING_FLOW'
  | 'COMPLETED'
  | 'FAILED'
  | unhandledEnumCase;

export type InstantiationTargetType =
  | 'HYBRID_FLOW'
  | 'UNIFIED_BUILDER'
  | 'INFER'
  | unhandledEnumCase;

export type ListInstantiationRequestsRequest = {
  templateId: number;
  offset: Default<number>;
  filterByUserId: Default<boolean>;
  statusFilter: Default<InstantiationStatus[]>;
  pageLength: Default<number>;
};

export type ListInstantiationRequestsResponse = {
  results: Default<InstantiationRequestItem[]>;
  hasMore: boolean;
  offset: number;
};

export type ListWorkflowsForTemplateRequest = {
  templateId: number;
  offset: Default<number>;
  pageLength: Default<number>;
};

export type ListWorkflowsForTemplateResponse = {
  results: Default<InstantiatedTemplateItem[]>;
  hasMore: boolean;
  offset: number;
};

export type UnresolvableReason =
  | 'AGENT_NOT_INSTALLED'
  | 'AGENT_RESOLUTION_ERROR'
  | unhandledEnumCase;

export type UnresolvedManifestEntry = {
  fieldType: FieldType;
  nodeId: string;
  fieldKey: string;
  reason: UnresolvableReason;
  message?: string;
};

export type WorkflowViewLocation = {
  type: WorkflowViewLocationType;
  objectTypeIds: Default<string[]>;
  url?: string;
};

export type WorkflowViewLocationType =
  | 'SIDE_PANEL'
  | 'MODERN_BUILDER'
  | 'LEGACY_BUILDER'
  | unhandledEnumCase;

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type InstantiateTemplateRequestType =
  Requestify<InstantiateTemplateRequest>;
export type InstantiateTemplateResponseType = InstantiateTemplateResponse;
export type InstantiateTemplateErrorType = InstantiateTemplateError &
  HubspotMetadata;
export const instantiateTemplateRpc: ChirpAvroRpcDetails<
  InstantiateTemplateRequestType,
  InstantiateTemplateResponseType,
  InstantiateTemplateErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'instantiateTemplate',
  auth: 'app',
  fingerprint: 'LwOCaXz8iL6pn7CVh1dwUN0LIIxqXL4B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstantiationStatusRequestType =
  Requestify<GetInstantiationStatusRequest>;
export type GetInstantiationStatusResponseType = GetInstantiationStatusResponse;
export type GetInstantiationStatusErrorType = GetInstantiationStatusError &
  HubspotMetadata;
export const getInstantiationStatusRpc: ChirpAvroRpcDetails<
  GetInstantiationStatusRequestType,
  GetInstantiationStatusResponseType,
  GetInstantiationStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'getInstantiationStatus',
  auth: 'app',
  fingerprint: 'QIJe6dqwsi1asdzO-RnSldrKPlNJ01-G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListInstantiationRequestsRequestType =
  Requestify<ListInstantiationRequestsRequest>;
export type ListInstantiationRequestsResponseType =
  ListInstantiationRequestsResponse;
export type ListInstantiationRequestsErrorType = EmptyError & HubspotMetadata;
export const listInstantiationRequestsRpc: ChirpAvroRpcDetails<
  ListInstantiationRequestsRequestType,
  ListInstantiationRequestsResponseType,
  ListInstantiationRequestsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'listInstantiationRequests',
  auth: 'app',
  fingerprint: 'sY2kt8fWxgqUN4AGQY94CpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListWorkflowsForTemplateRequestType =
  Requestify<ListWorkflowsForTemplateRequest>;
export type ListWorkflowsForTemplateResponseType =
  ListWorkflowsForTemplateResponse;
export type ListWorkflowsForTemplateErrorType = EmptyError & HubspotMetadata;
export const listWorkflowsForTemplateRpc: ChirpAvroRpcDetails<
  ListWorkflowsForTemplateRequestType,
  ListWorkflowsForTemplateResponseType,
  ListWorkflowsForTemplateErrorType,
  false
> = {
  serviceName:
    'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'listWorkflowsForTemplate',
  auth: 'app',
  fingerprint: 'B4OkBkjdj5J1ZtOmbv1J5ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
